import { S3_ENDPOINT } from 'constants/server/apiEndPoint';
import http, { endpoints } from '../http';
import { IS3UploadParams, IS3UploadSigningParams } from './models';

const datahubClient = http.createClient(`${endpoints.datahub}`);
const client = http.createClient('');

export default class S3Api {
  static async getS3Bucket(options?: { signal?: AbortSignal }) {
    const response = await datahubClient.get<string>(S3_ENDPOINT, {
      signal: options?.signal,
    });
    return response?.data;
  }

  static async signS3Upload(params: IS3UploadSigningParams & { signal?: AbortSignal }) {
    const response = await datahubClient.post<{ preSignedUrl: string }>('/webshop/s3/upload/presigned', params, {
      signal: params.signal,
    });
    return response?.data;
  }

  static async s3Upload(params: IS3UploadParams & { signal?: AbortSignal }): Promise<string> {
    const { headers } = await client.put(params.preSignedUrl, params.file, {
      headers: {
        ['X-Amz-Acl']: 'public-read',
      },
      onUploadProgress: e => params.onProgress?.(e.total ? (e.loaded / e.total) * 100 : 0),
      signal: params.signal,
    });

    return headers.etag;
  }
}
